export default [
    {text: "VedioConference", value: "video_conference", isConference: true},
    {text: "VedioConferenceWithChat", value: "video_conference_with_chat", isConference: true, isChatable: true, isPublicChat: true},
    {text: "VedioConferenceWithChatRestricted", value: "video_conference_with_chat_restrict", isConference: true, isChatable: true},
    {text: "VotingOnly", value: "voting_only"},
    {text: "VotingAndChat", value: "voting_and_chat", isChatable: true, isPublicChat: true},
    {text: "VotingAndChatRestricted", value: "voting_with_chat_restrict",isChatable: true},
]